// API Configuration
const API_CONFIG = {
  BASE_URL: 'https://nk2lgsxkwf.execute-api.us-east-1.amazonaws.com/prod',
  AUTH_BASE_URL: 'https://dllbm5jyjf.execute-api.us-east-1.amazonaws.com', // Auth Service API Gateway
  ENDPOINTS: {
    REQUEST_OTP: '/auth/request-otp',
    VERIFY_OTP: '/auth/verify-otp',
    SET_PASSWORD: '/auth/set-password',
    SIGNIN: '/auth/signin',
    CHAT: '/tenanthelpai',
    DDF_TEST: '/ddf-test',
    GET_USER_PREFERENCES: '/get-user-preferences',
    SAVE_PROPERTY_TYPE_PREFERENCES: '/save-property-type-preferences',
    SAVE_BEDROOM_PREFERENCES: '/save-bedroom-preferences',
    SAVE_NEIGHBORHOOD_PREFERENCES: '/save-neighborhood-preferences',
    SAVE_FURNISHED_PREFERENCES: '/save-furnished-preferences',
    SAVE_RENTAL_TERM_PREFERENCES: '/save-rental-term-preferences',
    UPDATE_TENANT_PREFERENCES: '/update-tenant-preferences',
    UPDATE_USER_PROFILE: '/update-user-profile',
    UPDATE_TENANT_PROFILE: '/update-tenant-profile',
    GET_TENANT_PROFILE: '/get-tenant-profile',
    // Equifax and Credit Reports (encrypted storage)
    EQUIFAX_ONEVIEW: '/equifax/oneview',
    CREDIT_REPORT_GET: '/credit-report',
    CREDIT_REPORTS_LIST: '/credit-reports/list',
    CREDIT_REPORTS_SHARING_STATUS: '/credit-reports/sharing-status',
    // Unread messages
    GET_UNREAD_COUNT: '/get-unread-messages-count',
    MARK_MESSAGES_READ: '/mark-messages-read'
  }
};

export default API_CONFIG; 